import {
  compose,
  withAuthorized,
  withBaseLayout,
  withHelmet
} from '../../../core';
import { ClientAppointmentView } from '../../../features/clients/ClientAppointmentView';

export const ClientAppointmentViewPage = compose(
  withAuthorized,
  withBaseLayout,
  withHelmet({
    title: 'Splashworks: Client appointments'
  })
)(ClientAppointmentView);
